import { useDataProvider, useNotify } from 'react-admin'
import { parseUserFormToBackend, UserForm, UserFormType } from '@src/pages/User/Show/CreateOrEdit/UserForm.tsx'
import { useSubmitLoader } from '@src/logic/contexts/utils/SubmitContext.tsx'
import { useDocumentTitle } from '@src/hooks/useDocumentTitle'
import styles from './UserForm.module.scss'
import { Dialog } from '@mui/material'
import { useModal } from '@logic/contexts/Modal/ModalContext.tsx'

type CreateUserModalProps = {
  onClosed?: (reason: 'created' | 'cancelled') => void
}

export const UserCreate: React.FC<CreateUserModalProps> = ({ onClosed }) => {
  useDocumentTitle('Add New Team Member')
  const { hideModal } = useModal()
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const { isFormSubmitting, setIsFormSubmitting } = useSubmitLoader()

  const onSubmit = async (formData: UserFormType) => {
    if (isFormSubmitting) {
      return
    }
    setIsFormSubmitting(true)

    try {
      await dataProvider.create('User', {
        data: parseUserFormToBackend(formData),
      })
      createdAndClose()
    } catch (error) {
      const errorMessage = error.message || 'Something went wrong, Please try again after sometime'
      notify(errorMessage, { type: 'error' })
    } finally {
      setIsFormSubmitting(false)
    }
  }

  const clearStorage = () => localStorage.removeItem('userCreateForm')

  const createdAndClose = () => {
    notify('User created successfully', { type: 'success' })
    clearStorage()
    onClosed?.('created')
    hideModal()
  }

  const clearAndClose = () => {
    clearStorage()
    onClosed?.('cancelled')
    hideModal()
  }

  return (
    <Dialog open role='dialog' aria-label='create-user-dialog-title' maxWidth='sm' fullWidth>
      <div className={styles.dialogHeader}>
        <h3 id='create-user-dialog-title'>Add New Team Member</h3>
      </div>

      <div data-page='create-user-model' className={styles.dialogContent}>
        <UserForm onSubmit={onSubmit} onCancel={clearAndClose} isSubmitting={isFormSubmitting}></UserForm>
      </div>
    </Dialog>
  )
}
